import { render, staticRenderFns } from "./SocialUnitAggregate.vue?vue&type=template&id=4f8e6b0d&scoped=true"
import script from "./SocialUnitAggregate.vue?vue&type=script&lang=js"
export * from "./SocialUnitAggregate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e6b0d",
  null
  
)

export default component.exports